import { HttpHeaders, HttpParams } from '@angular/common/http';

export type GenericHttpRequest<T> =
  | GenericHttpPostRequest<T>
  | GenericHttpGetRequest;

export interface GenericHttpPostRequest<T> extends GenericHttpBaseRequest {
  body?: T;
}
export interface GenericHttpGetRequest extends GenericHttpBaseRequest {}

interface GenericHttpBaseRequest {
  context: string;
  args?: { [key: string]: string | number | boolean };
  headers?: HttpHeaders;
  params?: HttpParams;
  responseType?: 'arraybuffer' | 'blob' | 'json' | 'text';
  observeResponse?: boolean;
}
